import { render, staticRenderFns } from "./DataPrograms.vue?vue&type=template&id=efb2319e"
import script from "./DataPrograms.vue?vue&type=script&lang=js"
export * from "./DataPrograms.vue?vue&type=script&lang=js"
import style0 from "./DataPrograms.vue?vue&type=style&index=0&id=efb2319e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports